import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Signature from "@/components/Signature";
import MenuSection from "@/components/MenuSection";
import Visit from "@/components/Visit";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div id="top" className="min-h-screen overflow-x-clip bg-cream font-body text-chalk antialiased">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Signature />
        <MenuSection />
        <Visit />
      </main>
      <Footer />
    </div>
  );
}
